import {Text, TextField} from '@/components/atoms'
import {usePromotion} from '@/context/Promotion/PromotionContext'
import {PointsReward, RewardType} from '@/types/promotion'
import {FC} from 'react'
import {RewardItemProps} from './RewardItem'
import {useRewardValidations} from './RewardValidations.js'


export const RewardPoints: FC<RewardItemProps> = ({promotionCondition}) => {
  const {updateCondition} = usePromotion()
  const { hasValueLayerError } = useRewardValidations(promotionCondition)

  const {rewards} = promotionCondition

  const updatePoints = (value: number | string) => {
    updateCondition({
      sequence: promotionCondition.sequence,
      rewards: [
        {
          type: RewardType.POINTS,
          points: Number(value),
        },
      ],
    })
  }

  const handleKeyDown = e => {
    const {key} = e
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete']

    if ((key >= '0' && key <= '9') || allowedKeys.includes(key)) {
      return
    }

    e.preventDefault()
  }

  const handlePointsChange = (value) => {

    const isValid = /^-?\d+$/.test(value) || value === ''
    const oldValue = (rewards?.[0] as PointsReward)?.points || ''
    const newValue = isValid ? value : oldValue
    //This is a bug in peacock TextInput, if we pass the same value to the input, it will not trigger the onChange event
    updatePoints(value)
    setTimeout(() => {
      updatePoints(newValue)
    }, 0)
  }

  const points = (rewards?.[0] as PointsReward)?.points || ''
  const isError = hasValueLayerError()

  return (
    <>
      <TextField
        updateValue={handlePointsChange}
        value={!Number.isNaN(points) ? points.toString() : ''}
        error={isError ? 'Value Invalid' : ''}
        uiSchema={{
                  helperText: '',
                  placeholder: '0',
                }}
        // @ts-ignore
        style={{maxWidth: '400px'}}
        type='number'
      />
      <Text>{'points.'}</Text>
    </>
  )
}
